var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "zoom-manager" }, [
    _c(
      "div",
      {
        staticClass: "btn",
        class: { disabled: _vm.isMin },
        on: { click: _vm.decreaseZoom },
      },
      [_c("i", { staticClass: "fa fa-minus" })]
    ),
    _vm._v(" "),
    _c("div", { staticClass: "label" }, [
      _vm._v("\n        " + _vm._s(_vm.label) + "\n    "),
    ]),
    _vm._v(" "),
    _c(
      "div",
      {
        staticClass: "btn",
        class: { disabled: _vm.isMax },
        on: { click: _vm.increaseZoom },
      },
      [_c("i", { staticClass: "fa fa-plus" })]
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }